export default function($) {
  const homeSwiper = new Swiper('.js-home-slides', {
    slidesPerView: 1,
    autoHeight: true,
    autoplay: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
}
